import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { ReportsService } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { MarkdownService } from '../../services/markdown.service';

@Component({
  selector: 'vrm-grid-alert-action-required-button',
  template: `
    <span>
      <button
        mat-button
        vrm-button
        fxFlex
        class="grid-text-centred force grid-text"
        style="color: white"
        (click)="triggerLinkButtonAction()"
      >
        {{ value }}
      </button>
    </span>
  `,
  styles: [],
})
export class GridAlertActionRequiredButtonComponent implements ICellRendererAngularComp {
  public value: string;
  private additionalContent: string;

  constructor(
    private cService: CommonService,
    public rptService: ReportsService,
    private markdownService: MarkdownService
  ) {}

  agInit(params: { value: any }) {
    this.value = params.value;
    this.additionalContent = this.rptService.currentReportMeta?.information?.alertContent;
  }

  triggerLinkButtonAction() {
    if (this.cService.userProfile.userPermissions.permVrmAlerts === 'view') {
      setTimeout(() => {
        this.setSideNavElementsDefaultStatus();
        this.rptService.showReportSideNav = true;
        this.rptService.resolveAlertButtonText = this.cService.readyTranslations.generic.update;
        this.rptService.reportSideNavTitle = this.cService.readyTranslations.generic.details;
        this.rptService.activeReportSideNavContent = this.rptService.reportSideNavContents.alerts;
        this.rptService.resolveAlertAdditionalContent = this.additionalContent
          ? this.markdownService.parse(this.additionalContent)
          : null;
        this.rptService.resolveAlertDisplayAuthorisation =
          this.rptService.currentReportMeta?.information?.alertDisplayAuthorisation;
      }, 150);
    } else {
      this.cService.showToast(
        this.cService.readyTranslations.messagesAndWarnings.insufficientPermissionToViewRequestedPage,
        3000
      );
    }
  }

  /*
   * if alert status is unresolved, show the form elements
   * if not then just show the comments for the action taken
   */
  setSideNavElementsDefaultStatus() {
    this.rptService.resolveAlertShowActionTaken =
      this.rptService.selectedRows[0].alertResolvedStatus.toLowerCase() === 'unresolved' ? false : true;
  }

  refresh() {
    return false;
  }
}
